/* tslint:disable */
/* eslint-disable */
export enum WorkExchangeRateSourceEnum {
  Bazg = 'bazg',
  Manual = 'manual'
}
